import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"

interface ShipToFilterChipProps {
  selectedShipToLocation?: string
  shipToLocations?: PriceChangeFilterLookupItem[]
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const ShipToFilterChip: React.FC<ShipToFilterChipProps> = ({ selectedShipToLocation, onRemove, shipToLocations }) => {
  const shipToLocationLabel = useMemo(
    () => shipToLocations?.find((shipToLocation) => shipToLocation.id === selectedShipToLocation)?.label ?? "",
    [selectedShipToLocation, shipToLocations]
  )

  return (
    <FilterChip
      key='pricing.ship-to-filter-chip'
      data-testid='pricing.ship-to-filter-chip'
      label={`Ship To: ${shipToLocationLabel}`}
      onDelete={() => onRemove("shipToId", undefined)}
    />
  )
}

export default ShipToFilterChip
